import { Action } from '@ngrx/store'
import * as DocumentTypesTypes from './document-types.types'
import { DocumentType } from './document-types.interface'

// Fetch DocumentType Types
export class FetchDocumentTypesRequest implements Action {
  readonly type = DocumentTypesTypes.FETCH_DOCUMENT_TYPES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchDocumentTypesSuccess implements Action {
  readonly type = DocumentTypesTypes.FETCH_DOCUMENT_TYPES_SUCCESS
  constructor(
    public payload: DocumentType[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchDocumentTypesFailure implements Action {
  readonly type = DocumentTypesTypes.FETCH_DOCUMENT_TYPES_FAILURE
  constructor(public payload: any) {}
}

// Fetch DocumentType Type
export class FetchDocumentTypeRequest implements Action {
  readonly type = DocumentTypesTypes.FETCH_DOCUMENT_TYPE_REQUEST
  constructor(public id: number) {}
}

export class FetchDocumentTypeSuccess implements Action {
  readonly type = DocumentTypesTypes.FETCH_DOCUMENT_TYPE_SUCCESS
  constructor(public payload: DocumentType) {}
}

export class FetchDocumentTypeFailure implements Action {
  readonly type = DocumentTypesTypes.FETCH_DOCUMENT_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Delete DocumentType Type
export class DeleteDocumentTypeRequest implements Action {
  readonly type = DocumentTypesTypes.DELETE_DOCUMENT_TYPE_REQUEST
  constructor(public id: number) {}
}

export class DeleteDocumentTypeSuccess implements Action {
  readonly type = DocumentTypesTypes.DELETE_DOCUMENT_TYPE_SUCCESS
  constructor() {}
}

export class DeleteDocumentTypeFailure implements Action {
  readonly type = DocumentTypesTypes.DELETE_DOCUMENT_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Create DocumentType Type
export class CreateDocumentTypeRequest implements Action {
  readonly type = DocumentTypesTypes.CREATE_DOCUMENT_TYPE_REQUEST
  constructor(public payload) {}
}

export class CreateDocumentTypeSuccess implements Action {
  readonly type = DocumentTypesTypes.CREATE_DOCUMENT_TYPE_SUCCESS
  constructor() {}
}

export class CreateDocumentTypeFailure implements Action {
  readonly type = DocumentTypesTypes.CREATE_DOCUMENT_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Update DocumentType Type
export class UpdateDocumentTypeRequest implements Action {
  readonly type = DocumentTypesTypes.UPDATE_DOCUMENT_TYPE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateDocumentTypeSuccess implements Action {
  readonly type = DocumentTypesTypes.UPDATE_DOCUMENT_TYPE_SUCCESS
  constructor() {}
}

export class UpdateDocumentTypeFailure implements Action {
  readonly type = DocumentTypesTypes.UPDATE_DOCUMENT_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = DocumentTypesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = DocumentTypesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateDocumentTypeRequest
  | UpdateDocumentTypeSuccess
  | UpdateDocumentTypeFailure
  | FetchDocumentTypesSuccess
  | FetchDocumentTypesFailure
  | FetchDocumentTypesRequest
  | FetchDocumentTypeSuccess
  | FetchDocumentTypeFailure
  | FetchDocumentTypeRequest
  | CreateDocumentTypeRequest
  | CreateDocumentTypeSuccess
  | CreateDocumentTypeFailure
  | DeleteDocumentTypeRequest
  | DeleteDocumentTypeSuccess
  | DeleteDocumentTypeFailure
  | SetDefaultData
  | UpdateField
  | FetchDocumentTypesRequest
  | FetchDocumentTypesSuccess
  | FetchDocumentTypesFailure
